import React, { useEffect, useState } from 'react';
import * as client from '@boostpoint/client-sdk';
import { ApiContext } from './context';
import { useAuth } from '../AuthProvider';

const ApiProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;
  const [ready, setReady] = useState(false);
  const mode = import.meta.env.MODE;
  const { getToken, currentUser } = useAuth();
  let environment: client.BoostpointCreateAiEnvironment;

  switch (mode) {
    case 'production':
      environment = client.BoostpointCreateAiEnvironment.Production;
      break;
    case 'staging':
      environment = client.BoostpointCreateAiEnvironment.Staging;
      break;
    default:
      environment = client.BoostpointCreateAiEnvironment.Development;
  }

  useEffect(() => {
    client.OpenAPI.BASE = environment;
    if (currentUser?.uid) {
      client.OpenAPI.TOKEN = async () => {
        return await getToken();
      };
      setReady(true);
    } else {
      client.OpenAPI.TOKEN = undefined;
      setReady(false);
    }
  }, [environment, currentUser?.uid, getToken]);

  const wrapped = {
    client,
    ready,
    environment,
  };

  return <ApiContext.Provider value={wrapped}>{children}</ApiContext.Provider>;
};
export default ApiProvider;
